import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ScrollText, Loader2, ShieldAlert } from "lucide-react";

const ACTION_TONE = (action) =>
  action.includes("remove") || action.includes("delete") || action.includes("revoke")
    ? "bg-red-50 text-red-700 border-red-200"
    : action.includes("impersonate")
      ? "bg-amber-50 text-amber-800 border-amber-200"
      : action.includes("create") || action.includes("signup")
        ? "bg-emerald-50 text-emerald-700 border-emerald-200"
        : "bg-royal/5 text-royal border-royal/15";

export default function Activity() {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api.get("/audit", { params: { limit: 200 } }).then(({ data }) => setRows(data));
  }, []);

  if (!rows) return <Loader2 className="h-6 w-6 animate-spin text-royal" />;

  return (
    <div className="space-y-6" data-testid="activity-page">
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-gold font-semibold">Accountability</p>
        <h1 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold text-royal-deep mt-2">Activity & Audit Trail</h1>
        <p className="text-muted-foreground mt-3 text-sm md:text-base">
          Every privileged action taken inside your organization, newest first.
        </p>
      </div>

      {rows.length === 0 ? (
        <div className="rounded-lg border border-dashed border-royal/25 bg-white p-10 text-center">
          <ScrollText className="h-7 w-7 text-gold mx-auto" />
          <p className="font-display text-lg font-semibold text-royal-deep mt-3">No activity recorded yet</p>
          <p className="text-sm text-muted-foreground mt-1">
            Privileged actions — team changes, settings updates, invitations — will appear here.
          </p>
        </div>
      ) : (
        <div className="rounded-lg border border-border bg-white divide-y divide-border overflow-hidden">
          {rows.map((r) => (
            <div key={r._id} data-testid={`audit-row-${r._id}`} className="px-4 sm:px-5 py-3.5">
              <div className="flex flex-wrap items-center gap-2">
                <span
                  className={`rounded-full border px-2.5 py-0.5 text-[11px] font-semibold ${ACTION_TONE(r.action)}`}
                >
                  {r.action}
                </span>
                <p className="text-sm font-semibold text-royal-deep">{r.actor_name || "System"}</p>
                {r.impersonated && (
                  <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-amber-700">
                    <ShieldAlert className="h-3 w-3" /> platform admin
                  </span>
                )}
                <p className="ml-auto text-[11px] text-muted-foreground">
                  {new Date(r.created_at).toLocaleString()}
                </p>
              </div>
              {(r.detail || r.resource) && (
                <p className="mt-1.5 text-xs text-muted-foreground">
                  {r.resource}
                  {r.detail ? ` · ${r.detail}` : ""}
                </p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
